var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8778 19.6976V6.22727C19.8778 5.1227 18.9823 4.22727 17.8778 4.22727H14.2M19.8778 19.6976V19.6976C20.2214 19.6976 20.5 19.9762 20.5 20.3198V20.985C20.5 21.2694 20.2694 21.5 19.985 21.5H18.9056C18.025 21.5 17.3111 20.7861 17.3111 19.9056V19.6976M19.8778 19.6976H17.3111M3.7 19.6976V6.22727C3.7 5.1227 4.59543 4.22727 5.7 4.22727H9.53333M3.7 19.6976H6.18889M3.7 19.6976V19.6976C3.3134 19.6976 3 20.011 3 20.3976V20.985C3 21.2694 3.23056 21.5 3.51496 21.5H4.59444C5.47503 21.5 6.18889 20.7861 6.18889 19.9056V19.6976M7.74444 3.55138V7.90711M7.74444 19.6976V16.0929M7.74444 19.6976H6.18889M7.74444 19.6976H10M15.9889 3.55138V7.90711M15.9889 19.6976V16.0929M15.9889 19.6976H17.3111M15.9889 19.6976H13.6556M3 16.0929H7.74444M20.5 16.0929H15.9889M15.9889 16.0929H7.74444M15.9889 16.0929V7.90711M7.74444 16.0929V7.90711M3 7.90711H7.74444M20.5 7.90711H15.9889M15.9889 7.90711H7.74444M10 19.6976V19.0808C10 18.4953 10.0537 17.8675 10.4632 17.4489C10.7462 17.1596 11.1686 16.919 11.7889 16.919C12.6519 16.919 13.1318 17.3119 13.3882 17.6618C13.6239 17.9835 13.6556 18.3972 13.6556 18.7961V19.6976M10 19.6976H13.6556M9.53333 4.22727V4.22727C9.53333 3.27333 10.3067 2.5 11.2606 2.5H12.4727C13.4267 2.5 14.2 3.27333 14.2 4.22727V4.22727M9.53333 4.22727H14.2",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbc);
export default __webpack_public_path__ + "static/media/ibc.a22a88222ad66328b94320b883a56ccf.svg";
export { ForwardRef as ReactComponent };